module.exports = __webpack_public_path__ + "static/img/yeswecan0015.3753803.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0015.png
// module id = 581
// module chunks = 1